import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import { IoIosRefresh } from "react-icons/io";
import { toast, ToastContainer } from 'react-toastify';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import config from "./config";

function Adminwallet() {

    const [adminAmount, setAdminAmount] = useState(0);
    const [adminDepositHistory, setAdminDepositHistory] = useState([]);
    const [adminWalletAddress, setAdminWalletAddress] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [copiedValue, setCopiedValue] = useState('');
    // console.log("adminAmount---", adminAmount);
    const [loading, setloading] = useState(false);

    useEffect(() => {
        adminWalletAmount();
        adminDepositHis();
    }, []);

    function convertTimestamp(timestamp) {
        const date = new Date(timestamp * 1000);

        const localTime = new Date(date.getTime());

        const day = String(localTime.getDate()).padStart(2, "0");
        const month = String(localTime.getMonth() + 1).padStart(2, "0");
        const year = localTime.getFullYear();

        let hours = localTime.getHours();
        const minutes = String(localTime.getMinutes()).padStart(2, "0");
        const seconds = String(localTime.getSeconds()).padStart(2, "0");

        // Convert to 12-hour format
        const period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // If hours == 0 (midnight), set it to 12

        // Format the time in 12-hour format with AM/PM
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${period}`;
    }

    const adminWalletAmount = async () => {
        try {
            let params = {
                url: `getadmin`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("response---", response);
            if (response.status) {
                const adminAmount = response?.findAdmin[0]?.adminWalletAmount;
                // console.log("adminAmount--", adminAmount);

                const adminWalletAddress = response?.findWalletAddress?.coinaddress;
                setAdminAmount(adminAmount);
                setAdminWalletAddress(adminWalletAddress);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const adminDepositHis = async () => {
        try {
            setloading(true);
            let params = {
                url: `getadmindepositHis`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("getadmindepositHis---", response);
            if (response.status) {
                setAdminDepositHistory(response.findAdminHis);
            }
        } catch (error) {
            console.log('error', error);
        }finally {
            setloading(false);
        }
    };

    const adminWallet = async () => {
        try {
            const params = { url: `admindeposit`, method: 'POST' };
            const response = await makeApiRequest(params);
            console.log("adminWallet---", response);

            if (response.status) {
                toast.success(response.message);
            } else {
                toast.warn(response.message);
            }

            // Run both calls in parallel
            await Promise.all([adminDepositHis(), adminWalletAmount()]);
        } catch (error) {
            console.log("error", error);
            toast.error("Something went wrong while refreshing");
        } 
    };


    // const adminWallet = async () => {        
    //     setloading(true);
    //     try {
    //         let params = {
    //             url: `admindeposit`,
    //             method: 'POST',
    //         };
    //         let response = await makeApiRequest(params);
    //         // console.log("adminWallet---", response);
    //         if (response.status) {
    //             toast.success(response.message);
    //             setloading(false);
    //             adminDepositHis();
    //             adminWalletAmount();
    //         } else {
    //             toast.warn(response.message);
    //             setloading(false);
    //             adminDepositHis();
    //             adminWalletAmount();
    //         }
    //     } catch (error) {
    //         // console.log('error', error);
    //     }
    // };

    const compressString = (str) => {
        if (!str) {
            return '';
        }
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };

    const handleCopy = (value) => {
        toast.success("Address Copied")
        setCopiedValue(value);
        setTimeout(() => setCopiedValue(''), 2000);
    };

    const columnsone = [
        {
            name: 'S.No',
            width: '80px',
            selector: (row, index) => index + 1 + (currentPage - 1) * perPage,
            sortable: false
        },
        {
            name: 'Date',
            selector: row => convertTimestamp(row.Timestamp),
            sortable: true,
            width: '200px',

        },
        {
            name: 'FromAddress',
            selector: row => (
                <div className="no-wrap-cell">
                    {row.FromAddress ? (
                        <>
                            {compressString(row.FromAddress)}
                            <CopyToClipboard className="ms-2" text={row.FromAddress} onCopy={() => handleCopy(row.FromAddress)}>
                                <FontAwesomeIcon icon={faCopy} />
                            </CopyToClipboard>
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'ToAddress',
            selector: row => (
                <div className="no-wrap-cell">
                    {row.ToAddress ? (
                        <>
                            {compressString(row.ToAddress)}
                            <CopyToClipboard className="ms-2" text={row.ToAddress} onCopy={() => handleCopy(row.ToAddress)}>
                                <FontAwesomeIcon icon={faCopy} />
                            </CopyToClipboard>
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'TransferHash',
            selector: row => {
                return (
                    <a href={`${config.TEXA_URL}${row.TransferHash}`} target="_blank" rel="noopener noreferrer">
                        {compressString(row.TransferHash)}
                    </a>
                );
            },
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => row.UsdtAmount > 0 ? row.UsdtAmount.toFixed(2) : '-',
            sortable: true,
        },
    ];

    const dataone = [
        {
            id: 1,
            sno: 'S.No',
            date: <div>Sandwich</div>,
            name: <div>0x5d4…7a1ac</div>,
            amount:
                <div className="latest-amounts">
                    $2.36
                </div>,
        },
    ];

    return (
        <div className='App'>
            <ToastContainer />
            <div className='container'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3   justify-content-between">
                                <h3 className="component-user ms-lg-0">Admin Wallet</h3>
                                <h4 style={{ color: "rgb(9 116 155)", textDecoration: "underline" }}>Description</h4>
                                <p>*This wallet Manage the manual transfer of coins to users.</p>
                                <p>*The admin is responsible for managing this wallet. Please click the refresh button to update the balance.</p>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className='site-admin-add-1'>
                                        <div className='mb-3'>
                                            {loading ? (
                                                <button className='refresh-btn'>
                                                    <div class="spinner-border " style={{ width: "20px", height: "20px" }} role="status">
                                                        <span class="visually-hidden ">Loading...</span>
                                                    </div>
                                                </button>

                                            ) : (
                                                <button
                                                    className='refresh-btn fw-bold'
                                                    onClick={adminWallet}
                                                >
                                                    Refresh
                                                </button>
                                            )}


                                        </div>
                                        <form>

                                            <div class="mb-3">
                                                <div className='d-flex justify-content-between'>
                                                    <label for="exampleInputEmail1" class="form-label">Wallet Address</label>
                                                </div>

                                                <input type="email" disabled class="form-control  custom-input-1" id="exampleInputEmail1"
                                                    value={adminWalletAddress ? adminWalletAddress : ''}
                                                    aria-describedby="emailHelp" />
                                            </div>
                                            <div class="mb-3">
                                                <label for="exampleInputPassword1" class="form-label">Amount</label>
                                                <input type="text" disabled
                                                    value={adminAmount > 0 ? adminAmount.toFixed(5) : 0}
                                                    class="form-control  custom-input-1" id="exampleInputPassword1" />
                                            </div>
                                            {/* <div className="text-center">
                                                <button type="submit" className="register-btn-spinner-1">Confirm</button>
                                            </div> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='custom-datascroll'>
                                        <DataTable
                                            columns={columnsone}
                                            data={adminDepositHistory.slice((currentPage - 1) * perPage, currentPage * perPage)} // Only show paginated data
                                            pagination
                                            paginationServer
                                            paginationRowsPerPageOptions={[5, 10, 20, 30, 50]}  // Include 5 as a valid option
                                            paginationTotalRows={adminDepositHistory.length}
                                            paginationPerPage={perPage}
                                            paginationDefaultPage={currentPage}
                                            onChangePage={(page) => setCurrentPage(page)}
                                            onChangeRowsPerPage={(newPerPage, page) => {
                                                setPerPage(newPerPage);
                                                setCurrentPage(page);
                                            }}
                                            highlightOnHover
                                            dense
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Adminwallet